<template>
  <component
    :is="currentComponent"
    v-if="currentComponent"
    v-bind="currentProperties"
    v-on="currentListeners"
  />
</template>

<script setup lang="ts">
import { shallowRef, onMounted, watch, computed } from "vue";
import { useComponentFactory } from "@/composables/useComponentFactory";

interface Props {
  identifier: string;
}

const props = defineProps<Props>();

const { createComponent } = useComponentFactory();

const currentComponent = shallowRef(null);

const currentProperties = computed(() => {
  switch (currentComponent.value) {
    default:
      return {};
  }
});

const currentListeners = computed(() => {
  switch (currentComponent.value) {
    default:
      return {};
  }
});

onMounted(() => {
  currentComponent.value = createComponent(props.identifier);
});

watch(
  () => props.identifier,
  (newIdentifier) => {
    currentComponent.value = null;
    currentComponent.value = createComponent(newIdentifier);
  },
  { immediate: true }
);

defineExpose({
  currentComponent,
  currentProperties,
  currentListeners,
});
</script>
